import { PDFDownloadLink, PDFViewer, pdf } from "@react-pdf/renderer";
import RptMemo from "./RptMemo";
import { useSelector } from "react-redux";
import { enum_Report_Type, ReportTemplateComponents } from "./ReportUtility";
import RptInvoice from "./RptInvoice";
import RptVoucher from "./RptVoucher";
import { isMobile } from "react-device-detect";
import { useEffect, useState } from "react";
import { Button } from "@heroui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownLong, faPrint } from "@fortawesome/free-solid-svg-icons";
import { apiRoute } from "../../constants/enum";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import RptSaleMemo from "./RptSaleMemo";
import RptPacketTransfer from "./RptPacketTransfer";

const ReportViewer = ({ props_ReportType }) => {

  const { rptData, modSettingData } = useSelector((state) => state.memoEntry);
  const { rptInvData } = useSelector((state) => state.invoiceEntry);
  const { rptPktData ,pktModSetData} = useSelector((state) => state.pktTransfer);
  const { recVouDetail } = useSelector((state) => state.receiveEntry);
  const { payVouDetail } = useSelector((state) => state.paymentEntry);
  const { CurrencySetting } = useSelector((state) => state.company);
  const [fontSize, setFontSize] = useState("1");
  const [isTempFetch, setIsTempFetch] = useState("0");
  //const [terms, setIsTempFetch] = useState("0");
  const randomPdfName = Math.random().toString(36).substring(2, 7);

  // Fetch template code for MEMO
  const { data: tempData = [], mutate: filterTemp } = usePost({
    url: apiRoute.reportTemplate.fetchReportTemp,
    queryKey: "Memo Template Data List",
    onSuccessTasks: (data) => {
      if (data && data.length > 0)
        setIsTempFetch("1")
      else
        setIsTempFetch("2")

    }
  });
  console.log(tempData,props_ReportType)

  useEffect(() => {
    filterTemp({
      data: {
        compcode: 1,
        report_type:props_ReportType==enum_Report_Type.MEMO? enum_Report_Type.SALEMEMO:
        props_ReportType==enum_Report_Type.INVOICE? enum_Report_Type.SALEINVOICE:""
      }
    })
  }, [])
  // Template → Component Map
  // const templateComponents = {
  //   SMTMP2: RptSaleMemo,
  //   SMTMP1: RptMemo,
  //   SINVTMP1: RptInvoice,
  //   RCV: RptVoucher,
  //   PAY: RptVoucher
  // };
  const componentMap = {
  RptSaleMemo,
  RptMemo,
  RptInvoice,
  RptVoucher
};
const templateComponents = ReportTemplateComponents
  .flatMap(item => item.data)
  .reduce((acc, cur) => {
    acc[cur.Code] =componentMap[cur.Component];  // maps "RptMemo" → RptMemo
    return acc;
  }, {});

 
  // -----------------------------
  // 🔥 Dynamic Report Component Loader
  // -----------------------------
  const getReportComponent = () => {

    let Comp = null;
    
    if (isTempFetch != "0") {
      if (props_ReportType === enum_Report_Type.MEMO) {
        const code = tempData?.[0]?.TempCode || "SMTMP1"; 
        Comp = templateComponents[code];

        return (
          <Comp
            fsize={fontSize}
            currencysetting={CurrencySetting}
            moddata={modSettingData}
            rptdata={rptData}
            termsdata={tempData}
          />
        );

      }

      if (props_ReportType === enum_Report_Type.INVOICE) {
        const code = tempData?.[0]?.TempCode || "SINVTMP1"; 
        Comp = templateComponents[code];

        return (
          <Comp
            fsize={fontSize}
            currencysetting={CurrencySetting}
            moddata={modSettingData}
            rptdata={rptInvData}
            termsdata={tempData}
          />
        );
        //return <RptInvoice fsize={fontSize} moddata={modSettingData} rptdata={rptInvData} />;
      }

      if (props_ReportType === enum_Report_Type.RECVOUCHER) {
        return <RptVoucher fsize={fontSize} data={recVouDetail} />;
      }

      if (props_ReportType === enum_Report_Type.PAYVOUCHER) {
        return <RptVoucher fsize={fontSize} data={payVouDetail} />;
      }
       if (props_ReportType === enum_Report_Type.PACKETTRANSFER) {
        return <RptPacketTransfer fsize={fontSize} moddata={pktModSetData} rptdata={rptPktData} />;
      }
    }
    

  };

  // -----------------------------
  // 🔥 Print PDF
  // -----------------------------
  const handlePrint = async () => {
    const report = getReportComponent();
    if (!report) return alert("Report not ready");

    const blob = await pdf(report).toBlob();
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      iframe.contentWindow.onafterprint = () => {
        document.body.removeChild(iframe);
        URL.revokeObjectURL(url);
      };
    };
  };

  // -----------------------------
  // 🔥 Main UI
  // -----------------------------
  const hasData =
    (rptData?.length > 0) ||
    (rptInvData?.length > 0) ||
    (recVouDetail?.length > 0) ||
    (payVouDetail?.length > 0);

  if (!hasData) {
    return (
      <div style={{
        background: "rgb(235, 107, 22)",
        textAlign: "center",
        color: "white",
        padding: "10px",
        marginBottom: "10px"
      }}>
        Data not found
      </div>
    );
  }


  return (
    <div className="bg-white" style={{ margin: 10 }}>
      {isMobile ? (
        <>
          {/* MOBILE DOWNLOAD */}
          <PDFDownloadLink
            document={isTempFetch !== "0" ? getReportComponent() : ''}
            fileName={randomPdfName + ".pdf"}
          >
            {({ loading }) =>
              loading ? "Loading..." : (
                <div style={{
                  background: "rgb(235, 107, 22)",
                  textAlign: "center",
                  color: "white",
                  padding: "10px"
                }}>
                  Download
                </div>
              )
            }
          </PDFDownloadLink>
        </>
      ) : (
        <>
          {/* DESKTOP CONTROLS */}
          <div className="flex mb-2 items-end gap-4">
            <div style={{
              backgroundColor: "#db7c07",
              borderRadius: "5px",
              color: "white",
              fontSize: "12px",
              padding: "6px"
            }}>
              <label>
                Size:&nbsp;
                <select
                  style={{ color: "#000", borderRadius: "5px" }}
                  value={fontSize}
                  onChange={(e) => setFontSize(e.target.value)}
                >
                  <option value="0.5">50</option>
                  <option value="0.6">60</option>
                  <option value="0.7">70</option>
                  <option value="0.8">80</option>
                  <option value="0.9">90</option>
                  <option value="1">100</option>
                </select>
              </label>
            </div>

            <Button
              onPress={handlePrint}
              variant="shadow"
              color="primary"
              size="sm"
              startContent={<FontAwesomeIcon icon={faPrint} />}
            >
              Print
            </Button>

            <PDFDownloadLink
              document={isTempFetch !== "0" ? getReportComponent() : ''}
              fileName={randomPdfName + ".pdf"}
            >
              {({ loading }) =>
                !loading && (
                  <Button
                    variant="shadow"
                    color="primary"
                    size="sm"
                    startContent={<FontAwesomeIcon icon={faDownLong} />}
                  >
                    Download PDF
                  </Button>
                )
              }
            </PDFDownloadLink>
          </div>

          {/* PDF VIEWER */}
          <PDFViewer showToolbar={false} width="100%" height="600px">
            {/* { tempData &&  tempData.length>0?isTempFetch == "1" ? getReportComponent() :isTempFetch=='2'?getReportComponent():'':''} */}
            {
              isTempFetch !== "0" ? getReportComponent() : ''
            }
          </PDFViewer>
        </>
      )}
    </div>
  );
};

export default ReportViewer;
